import { axios } from '../../services/axios';

// To be used specifically for number dropdown components
const getAvailableNumbersDropdown = async (currentCompany, platformID) => {
    const res = await axios.get(
        `/Company/${currentCompany}/Platform/${platformID}/Numbers/Available/Dropdown`,
    );
    return res.data;
};

export default getAvailableNumbersDropdown;
